<template>
    <div class="treeview-node" :id="`${value.id}_${value.type}`">
        <div @click="expand" :id="`${value.id}_${value.type}`">
            <tree-view-item :expanded="value.isExpanded" :value="value" :read-only="readOnly"></tree-view-item>
        </div>
            <div
                 v-for="item in value.items"
                 :key="item.id"
                 v-show="value.isExpanded"
                 :id="`${item.id}_${item.type}`"
                 :class="[{
                     'organization': item.type === 'Organization',
                     'fleet': item.type === 'Fleet',
                     'vehicle': item.type === 'Vehicle',
                     'device': item.type === 'Device',
                 }]"
            >
                <treeview-node-read-only :key="item.id" :value="item" :ref="`treeview-node-${item.id}`" :id="`${item.id}_${item.type}`" :tree-name="treeName" :level="level + 1"></treeview-node-read-only>
            </div>
        <sp-loader v-if="isLoading"></sp-loader>

    </div>

</template>

<script>
import TreeViewItem from '@/views/Tree/TreeViewItem'
import SpLoader from '@/components/atoms/Loader'
import TreeVehiclesApi from '@/api/TreeVehiclesApi'
import OrganizationVehicleTreeTransformer from '@/transformers/OrganizationVehicleTreeTransformer'

const treeVehicleApi = new TreeVehiclesApi()
const organizationVehicleTransformer = new OrganizationVehicleTreeTransformer()

export default {
    name: 'TreeviewNodeReadOnly',
    components: {
        TreeViewItem,
        SpLoader,
    },
    data () {
        return {
            isLoading: false,
            isFetched: false,
            readOnly: false
        }
    },
    props: {
        value: {
            type: [Object, Array]
        },
        treeName: {
            type: String,
            required: true
        },
        level: {
            type: Number,
            required: true
        },
    },
    methods: {
        getTreeVehicles: async function () {
            const response = await treeVehicleApi.getTreeVehicles({
                fleetId: this.value.id
            })

            let vehicles = []
            response.payload.forEach((vehicleItem) => {
                let vehicleTransformed = organizationVehicleTransformer.transform(vehicleItem)
                vehicleTransformed.setParent(this.value)
                vehicles.push(vehicleTransformed)
            })

            this.value.addVehicles(vehicles)
            this.value.isFetched = true
        },
        expand () {
            this.value.isExpanded = !this.value.isExpanded
            if ('Fleet' === this.value.type && !this.value.isFetched) {
                this.getTreeVehicles()
            }

            if (this.value.isExpanded && 0 === this.value.items.length) {
                this.isLoading = true
                this.loadData()
                this.isLoading = false
            }
        },
        loadData () {
            const type = this.value.type

            switch (type) {
                case 'Organization': return this.value.items
                case 'Fleet': return this.value.items
                case 'Vehicle': return this.value.items
                case 'Device': return null
            }
        },
    }
}
</script>

<style scoped lang="scss">
.treeview-node {
    padding-left: 8px;

    @media (min-width: 1200px) {
        padding-left: 20px;
    }
}

.sortable-ghost {
    width: 100%;
    padding-top: 10px;
    border-top: 2px solid $primary-default;
}

</style>
